import React from "react";
import { authWrapper } from "../../../api/serverApiHelpers";
import { ButtonProps, Button } from "../../../designSystem/button/Button";

export function DownloadActivityIcsButton(props: ButtonProps & { activityId: string }) {

    async function downloadIcsFile() {
        const response = await authWrapper(() => fetch(`/api/activities/${props.activityId}/ics`));
        if (response.status !== 200)
            throw new Error(`Failed to download activity calendar file (${response.status})`);

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${props.activityId}.ics`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    return (
        <Button {...props} onClick={downloadIcsFile} />
    );
}